import dayjs from 'dayjs'

import { usePortalStore } from '@/stores/portal.store'

export const useAvailability = () => {
  const portalStore = usePortalStore()

  const convertAvailability = (availability) => {
    if (!availability || availability.length === 0) {
      return []
    }
    return availability.map(i => {
      if (dayjs(i.start).isSame(dayjs(i.end), 'day')) {
        return dayjs(i.start).format('YYYY/MM/DD')
      }
      return {
        from: dayjs(i.start).format('YYYY/MM/DD'),
        to: dayjs(i.end).format('YYYY/MM/DD'),
      }
    }) || []
  }

  const isDateCovered = (markers, date) =>
    (markers || []).some(m => dayjs(m.start).isSameOrBefore(date, 'day') && dayjs(m.end).isSameOrAfter(date, 'day'))

  const isAvailableDate = (date, vacationMarkers, availabilityType) => {
    const covered = isDateCovered(vacationMarkers, dayjs(date))
    if (availabilityType === portalStore.serviceAvailabilityTypeEnum.USUALLY_UNAVAILABLE) {
      return covered
    }
    if (availabilityType === portalStore.serviceAvailabilityTypeEnum.USUALLY_AVAILABLE) {
      return !covered
    }
    return false
  }

  return {
    convertAvailability,
    isAvailableDate,
  }
}
